export default __webpack_public_path__ + "static/media/logo_oap.da63b185.svg";